<template>
  <main>
    <Transition name="fade">
      <Loader v-if="!$page || !$beet.isReady" />
    </Transition>
    <template v-if="$page && $beet.isReady">
      <Banner :content="bannerContent" />
      <PromoSection :content="promoSection" />
      <DetailedCardSection :cards="services" />
      <QuestionSection />
    </template>
  </main>
</template>

<script>
import Banner from '@/components/sections/Banner.vue'
import DetailedCardSection from '@/components/sections/DetailedCardSection.vue'
import PromoSection from '@/components/sections/PromoSection.vue'
import QuestionSection from '@/components/sections/QuestionSection.vue'
import Loader from '@/components/small/Loader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin'

export default {
  mixins: [PageMetaMixin],
  name: 'Services',
  beetPage: 'services',
  components: {
    Banner,
    DetailedCardSection,
    Loader,
    PromoSection,
    QuestionSection,
  },
  computed: {
    bannerContent() {
      return {
        image: this.$page.header.image,
        subtitle: this.$page.header.subtitle,
        title: this.$page.header.title,
      }
    },
    promoSection() {
      return {
        special: this.$beet.options.discounts.content,
        text: this.$page.description,
      }
    },
    services() {
      return Object.values(this.$beet.services).map((service) => {
        return {
          ...service,
          type: 'service',
        }
      })
    },
  },
}
</script>
